import { configureStore } from '@reduxjs/toolkit';
import alert from './alert/alertSlice';
import image from './Image/imageSlice';
import productPreview from './product/productPreviewSlice';
import project from './project/projectSlice';
import result from './result/resultSlice';
import soil from './soil/soilSlice';
import user from './user/userSlice';
import drainPipe from './drainPipe/drainPipeSlice';
import price from './price/priceSlice';
import util from './util/utilSlice';

export const redux = configureStore({
    reducer: {
        user,
        project,
        result,
        price,
        alert,
        productPreview,
        soil,
        drainPipe,
        image,
        util,
    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof redux.getState>;
export type AppDispatch = typeof redux.dispatch;
